import { render } from "./VolumeScatter.vue?vue&type=template&id=59e7bffc"
import script from "./VolumeScatter.vue?vue&type=script&lang=js"
export * from "./VolumeScatter.vue?vue&type=script&lang=js"

import "./VolumeScatter.vue?vue&type=style&index=0&id=59e7bffc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__